var _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.9864 69.3438C65.2833 70.9856 62.9573 72 60.3881 72C55.1717 72 50.9383 67.8221 50.9383 62.6683C50.9383 60.5601 51.6487 58.6154 52.8458 57.0529C54.5683 54.7933 57.303 53.3341 60.3881 53.3341C65.6044 53.3341 69.8281 57.512 69.8281 62.6683C69.8281 65.2837 68.7381 67.649 66.9864 69.3438Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5821 40H87.3749C88.8055 40 90.1874 40.5625 91.1995 41.5625C92.2117 42.5625 92.7761 43.9183 92.7761 45.3341V82.6659C92.7761 84.0817 92.2117 85.4375 91.1995 86.4375C90.1874 87.4375 88.8055 88 87.3749 88H33.4013C31.9707 88 30.5887 87.4375 29.5766 86.4375C28.5645 85.4375 28 84.0817 28 82.6659V45.3341C28 43.9183 28.5645 42.5625 29.5766 41.5625C30.0924 41.0577 30.6958 40.6635 31.3575 40.3966C31.9998 40.137 32.6908 40 33.4013 40H44.194L50.9383 32H69.8378L76.5821 40ZM52.1451 74.8606C54.5781 76.4736 57.449 77.3341 60.3881 77.3341C64.3295 77.3341 68.1055 75.7885 70.8889 73.0385C72.9326 71.0168 74.3243 68.4663 74.9082 65.7139C75.1223 64.7188 75.2293 63.6971 75.2293 62.6659C75.2293 59.7668 74.3632 56.9303 72.7282 54.5192C71.103 52.1058 68.777 50.226 66.0715 49.1154C63.3563 48.0072 60.3686 47.7163 57.4879 48.2812C54.617 48.8486 51.9699 50.2452 49.8872 52.2957C47.8143 54.3462 46.4032 56.9591 45.829 59.8053C45.2548 62.6514 45.5468 65.5986 46.6757 68.2788C47.7949 70.9591 49.7023 73.25 52.1451 74.8606Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 110,
    height: 110,
    rx: 55,
    strokeWidth: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.7591f70b9a0839ca0add2048a2170462.svg";
export { ForwardRef as ReactComponent };